/* Copyright (C) 2018-2019 SplendidCRM Software, Inc. All Rights Reserved. 
 * Any use of the contents of this file are subject to the SplendidCRM Professional Source Code License Agreement, or other written agreement between you and SplendidCRM ("License"). 
 * SplendidCRM owns all proprietary rights, including all copyrights, patents, trade secrets, and trademarks, in and to the contents of this file.  You will not link to or in any way 
 * combine the contents of this file or any derivatives with any Open Source Code in any manner that would require the contents of this file to be made available to any third party. 
 */

export default interface DYNAMIC_BUTTON
{
	ID                            : string;  // uniqueidentifier
	VIEW_NAME                     : string;  // nvarchar
	CONTROL_INDEX                 : number;  // int
	CONTROL_TYPE                  : string;  // nvarchar
	DEFAULT_VIEW                  : boolean; // bit
	MODULE_NAME                   : string;  // nvarchar
	MODULE_ACCESS_TYPE            : string;  // nvarchar
	TARGET_NAME                   : string;  // nvarchar
	TARGET_ACCESS_TYPE            : string;  // nvarchar
	MOBILE_ONLY                   : boolean; // bit
	ADMIN_ONLY                    : boolean; // bit
	EXCLUDE_MOBILE                : boolean; // bit
	CONTROL_TEXT                  : string;  // nvarchar
	CONTROL_TOOLTIP               : string;  // nvarchar
	CONTROL_ACCESSKEY             : string;  // nvarchar
	CONTROL_CSSCLASS              : string;  // nvarchar
	TEXT_FIELD                    : string;  // nvarchar
	ARGUMENT_FIELD                : string;  // nvarchar
	COMMAND_NAME                  : string;  // nvarchar
	URL_FORMAT                    : string;  // nvarchar
	URL_TARGET                    : string;  // nvarchar
	ONCLICK_SCRIPT                : string;  // nvarchar
	HIDDEN                        : boolean; // bit
	BUSINESS_RULE                 : string;  // nvarchar
	BUSINESS_SCRIPT               : string;  // nvarchar
	MODULE_ACLACCESS              : string;
	TARGET_ACLACCESS              : string;
}

